export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";